import { render, staticRenderFns } from "./NewInvestigatorForm.vue?vue&type=template&id=6a47e6b8&scoped=true"
import script from "./NewInvestigatorForm.vue?vue&type=script&lang=js"
export * from "./NewInvestigatorForm.vue?vue&type=script&lang=js"
import style0 from "./NewInvestigatorForm.vue?vue&type=style&index=0&id=6a47e6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a47e6b8",
  null
  
)

export default component.exports